/**
 * `pdf` merges every delivery note into one file, `zip` holds one PDF per delivery note.
 */
export const DELIVERY_NOTE_PDF_EXPORT_FORMATS = ['pdf', 'zip'] as const;
